module.exports = __webpack_public_path__ + "static/media/cover.7722b4cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/bokadirekt/cover.jpg
// module id = 49
// module chunks = 0